import { render } from "./bank_terminal.vue?vue&type=template&id=5ed2e1d6"
import script from "./bank_terminal.vue?vue&type=script&lang=js"
export * from "./bank_terminal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__